import React, { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";

interface IUsedProgressProps {
  title: string;
  used: number;
  limit: number;
}

export default function UsedProgress({
  title,
  used,
  limit,
}: IUsedProgressProps) {
  const [variant, setVariant] = useState("primary");

  const usedPercent = (used * 100) / limit;

  useEffect(() => {
    if (usedPercent > 90) {
      setVariant("danger");
    } else if (usedPercent >= 60) {
      setVariant("warning");
    } else {
      setVariant("primary");
    }
  }, [usedPercent]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="fw-bold fs-7 text-gray">{title}</div>
        <div>
          {used}/{limit}
        </div>
      </div>
      <div className={`${!usedPercent && "min-dot-progress"}`}>
        <ProgressBar
          now={usedPercent}
          visuallyHidden
          variant={variant}
          style={{ backgroundColor: "#F5F5F5", height: "12px" }}
        />
      </div>
    </div>
  );
}
